import {
  CampaignReview,
  ICampaign,
  CampaignAnalytics,
  CampaignFilters,
  CampaignPagination,
  CampaignContactCounts,
} from '../../types/campaigns/campaigns.types';
import {
  GET_CAMPAIGNS_REQUEST,
  GET_CAMPAIGNS_SUCCESS,
  GET_CAMPAIGNS_FAILURE,
  GET_CAMPAIGN_REQUEST,
  GET_CAMPAIGN_SUCCESS,
  GET_CAMPAIGN_FAILURE,
  CREATE_CAMPAIGN_REQUEST,
  CREATE_CAMPAIGN_SUCCESS,
  CREATE_CAMPAIGN_FAILURE,
  UPDATE_CAMPAIGN_REQUEST,
  UPDATE_CAMPAIGN_SUCCESS,
  UPDATE_CAMPAIGN_FAILURE,
  PUBLISH_CAMPAIGN_REQUEST,
  PUBLISH_CAMPAIGN_SUCCESS,
  PUBLISH_CAMPAIGN_FAILURE,
  GetCampaignsRequestAction,
  GetCampaignsSuccessAction,
  GetCampaignsFailureAction,
  GetCampaignRequestAction,
  GetCampaignSuccessAction,
  GetCampaignFailureAction,
  CreateCampaignRequestAction,
  CreateCampaignSuccessAction,
  CreateCampaignFailureAction,
  UpdateCampaignRequestAction,
  UpdateCampaignSuccessAction,
  UpdateCampaignFailureAction,
  PublishCampaignRequestAction,
  PublishCampaignSuccessAction,
  PublishCampaignFailureAction,
  CLEAR_CAMPAIGN_STATE,
  ClearCampaignStateAction,
  CLEAR_PUBLISH_CAMPAIGN_STATE,
  ClearPublishCampaignStateAction,
  REVIEW_CAMPAIGN_REQUEST,
  REVIEW_CAMPAIGN_SUCCESS,
  ReviewCampaignRequestAction,
  ReviewCampaignSuccessAction,
  ReviewCampaignFailureAction,
  REVIEW_CAMPAIGN_FAILURE,
  GET_CAMPAIGN_ANALYTICS_REQUEST,
  GET_CAMPAIGN_ANALYTICS_SUCCESS,
  GET_CAMPAIGN_ANALYTICS_FAILURE,
  GetCampaignAnalyticsRequestAction,
  GetCampaignAnalyticsSuccessAction,
  GetCampaignAnalyticsFailureAction,
  DUPLICATE_CAMPAIGN_REQUEST,
  DUPLICATE_CAMPAIGN_SUCCESS,
  DUPLICATE_CAMPAIGN_FAILURE,
  DuplicateCampaignRequestAction,
  DuplicateCampaignSuccessAction,
  DuplicateCampaignFailureAction,
  DELETE_CAMPAIGN_REQUEST,
  DELETE_CAMPAIGN_SUCCESS,
  DELETE_CAMPAIGN_FAILURE,
  DeleteCampaignRequestAction,
  DeleteCampaignSuccessAction,
  DeleteCampaignFailureAction,
  CLEAR_DELETE_STATE,
  ClearDeleteStateAction,
  PAUSE_CAMPAIGN_REQUEST,
  PAUSE_CAMPAIGN_SUCCESS,
  PAUSE_CAMPAIGN_FAILURE,
  PauseCampaignRequestAction,
  PauseCampaignSuccessAction,
  PauseCampaignFailureAction,
  GET_CAMPAIGN_CONTACT_COUNTS_REQUEST,
  GET_CAMPAIGN_CONTACT_COUNTS_SUCCESS,
  GET_CAMPAIGN_CONTACT_COUNTS_FAILURE,
  GetCampaignContactCountsRequestAction,
  GetCampaignContactCountsSuccessAction,
  GetCampaignContactCountsFailureAction,
  ClearPauseCampaignStateAction,
  CLEAR_PAUSE_CAMPAIGN_STATE,
} from './campaigns.types';

// Get Campaigns Actions
export const getCampaignsRequest = (
  filters?: CampaignFilters
): GetCampaignsRequestAction => ({
  type: GET_CAMPAIGNS_REQUEST,
  payload: filters,
});

export const getCampaignsSuccess = (
  campaigns: ICampaign[],
  pagination: CampaignPagination
): GetCampaignsSuccessAction => ({
  type: GET_CAMPAIGNS_SUCCESS,
  payload: { campaigns, pagination },
});

export const getCampaignsFailure = (
  error: string
): GetCampaignsFailureAction => ({
  type: GET_CAMPAIGNS_FAILURE,
  payload: error,
});

// Get Single Campaign Actions
export const getCampaignRequest = (
  campaignId: string
): GetCampaignRequestAction => ({
  type: GET_CAMPAIGN_REQUEST,
  payload: campaignId,
});

export const getCampaignSuccess = (
  campaign: ICampaign
): GetCampaignSuccessAction => ({
  type: GET_CAMPAIGN_SUCCESS,
  payload: campaign,
});

export const getCampaignFailure = (
  error: string
): GetCampaignFailureAction => ({
  type: GET_CAMPAIGN_FAILURE,
  payload: error,
});

// Create Campaign Actions
export const createCampaignRequest = (campaignData: {
  name: string;
}): CreateCampaignRequestAction => ({
  type: CREATE_CAMPAIGN_REQUEST,
  payload: campaignData,
});

export const createCampaignSuccess = (
  campaign: ICampaign
): CreateCampaignSuccessAction => ({
  type: CREATE_CAMPAIGN_SUCCESS,
  payload: campaign,
});

export const createCampaignFailure = (
  error: string
): CreateCampaignFailureAction => ({
  type: CREATE_CAMPAIGN_FAILURE,
  payload: error,
});

// Update Campaign Actions
export const updateCampaignRequest = (
  campaignId: string,
  campaignData: {
    name?: string;
    description?: string;
    goal?: any;
    exitSurvey?: string;
  }
): UpdateCampaignRequestAction => ({
  type: UPDATE_CAMPAIGN_REQUEST,
  payload: { campaignId, campaignData },
});

export const updateCampaignSuccess = (
  campaign: ICampaign
): UpdateCampaignSuccessAction => ({
  type: UPDATE_CAMPAIGN_SUCCESS,
  payload: campaign,
});

export const updateCampaignFailure = (
  error: string
): UpdateCampaignFailureAction => ({
  type: UPDATE_CAMPAIGN_FAILURE,
  payload: error,
});

// Publish Campaign Actions
export const publishCampaignRequest = (
  campaignId: string,
  selectedType?: 'all_contacts' | 'future_contacts'
): PublishCampaignRequestAction => ({
  type: PUBLISH_CAMPAIGN_REQUEST,
  payload: { campaignId, selectedType },
});

export const publishCampaignSuccess = (
  campaign: ICampaign
): PublishCampaignSuccessAction => ({
  type: PUBLISH_CAMPAIGN_SUCCESS,
  payload: campaign,
});

export const publishCampaignFailure = (
  error: string
): PublishCampaignFailureAction => ({
  type: PUBLISH_CAMPAIGN_FAILURE,
  payload: error,
});

export const clearCampaignState = (): ClearCampaignStateAction => ({
  type: CLEAR_CAMPAIGN_STATE,
});

export const clearPublishCampaignState =
  (): ClearPublishCampaignStateAction => ({
    type: CLEAR_PUBLISH_CAMPAIGN_STATE,
  });

// Review Campaign Actions
export const reviewCampaignRequest = (
  campaignId: string
): ReviewCampaignRequestAction => ({
  type: REVIEW_CAMPAIGN_REQUEST,
  payload: { campaignId },
});

export const reviewCampaignSuccess = (
  campaign: CampaignReview
): ReviewCampaignSuccessAction => ({
  type: REVIEW_CAMPAIGN_SUCCESS,
  payload: campaign,
});

export const reviewCampaignFailure = (
  error: string
): ReviewCampaignFailureAction => ({
  type: REVIEW_CAMPAIGN_FAILURE,
  payload: error,
});

// Get Campaign Analytics Actions
export const getCampaignAnalyticsRequest = (
  campaignId: string,
  startDate?: string,
  endDate?: string
): GetCampaignAnalyticsRequestAction => ({
  type: GET_CAMPAIGN_ANALYTICS_REQUEST,
  payload: { campaignId, startDate, endDate },
});

export const getCampaignAnalyticsSuccess = (
  analytics: CampaignAnalytics
): GetCampaignAnalyticsSuccessAction => ({
  type: GET_CAMPAIGN_ANALYTICS_SUCCESS,
  payload: analytics,
});

export const getCampaignAnalyticsFailure = (
  error: string
): GetCampaignAnalyticsFailureAction => ({
  type: GET_CAMPAIGN_ANALYTICS_FAILURE,
  payload: error,
});

// Duplicate Campaign Actions
export const duplicateCampaignRequest = (
  campaignId: string
): DuplicateCampaignRequestAction => ({
  type: DUPLICATE_CAMPAIGN_REQUEST,
  payload: campaignId,
});

export const duplicateCampaignSuccess = (
  campaign: ICampaign
): DuplicateCampaignSuccessAction => ({
  type: DUPLICATE_CAMPAIGN_SUCCESS,
  payload: campaign,
});

export const duplicateCampaignFailure = (
  error: string
): DuplicateCampaignFailureAction => ({
  type: DUPLICATE_CAMPAIGN_FAILURE,
  payload: error,
});

// Delete Campaign Actions
export const deleteCampaignRequest = (
  campaignId: string,
  filters?: CampaignFilters
): DeleteCampaignRequestAction => ({
  type: DELETE_CAMPAIGN_REQUEST,
  payload: { campaignId, filters },
});

export const deleteCampaignSuccess = (
  campaignId: string
): DeleteCampaignSuccessAction => ({
  type: DELETE_CAMPAIGN_SUCCESS,
  payload: { campaignId },
});

export const deleteCampaignFailure = (
  error: string
): DeleteCampaignFailureAction => ({
  type: DELETE_CAMPAIGN_FAILURE,
  payload: error,
});

export const clearDeleteState = (): ClearDeleteStateAction => ({
  type: CLEAR_DELETE_STATE,
});

// Pause Campaign Actions
export const pauseCampaignRequest = (
  campaignId: string
): PauseCampaignRequestAction => ({
  type: PAUSE_CAMPAIGN_REQUEST,
  payload: campaignId,
});

export const pauseCampaignSuccess = (
  campaign: ICampaign
): PauseCampaignSuccessAction => ({
  type: PAUSE_CAMPAIGN_SUCCESS,
  payload: campaign,
});

export const pauseCampaignFailure = (
  error: string
): PauseCampaignFailureAction => ({
  type: PAUSE_CAMPAIGN_FAILURE,
  payload: error,
});

export const clearPauseCampaignState = (): ClearPauseCampaignStateAction => ({
  type: CLEAR_PAUSE_CAMPAIGN_STATE,
});

// Get Campaign Contact Counts Actions
export const getCampaignContactCountsRequest = (
  campaignId: string
): GetCampaignContactCountsRequestAction => ({
  type: GET_CAMPAIGN_CONTACT_COUNTS_REQUEST,
  payload: campaignId,
});

export const getCampaignContactCountsSuccess = (
  contactCounts: CampaignContactCounts
): GetCampaignContactCountsSuccessAction => ({
  type: GET_CAMPAIGN_CONTACT_COUNTS_SUCCESS,
  payload: contactCounts,
});

export const getCampaignContactCountsFailure = (
  error: string
): GetCampaignContactCountsFailureAction => ({
  type: GET_CAMPAIGN_CONTACT_COUNTS_FAILURE,
  payload: error,
});
